import { useState } from 'react';
import { useEditorStore } from '../../stores/editorStore';

export default function LayersPanel() {
  const [expanded, setExpanded] = useState(true);
  const {
    editorLayers,
    objects,
    entities,
    entityLayerAssignments,
    layerVisibility,
    activeLayer,
    toggleLayerVisibility,
    setActiveLayer,
    createEditorLayer,
  } = useEditorStore();

  const handleCreateLayer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const name = window.prompt('Nombre de la nueva capa:');
    if (!name) return;
    createEditorLayer(name);
  };

  return (
    <div className="panel">
      <div className="panel-header" onClick={() => setExpanded(!expanded)}>
        <span>
          Layers ({editorLayers.length})
        </span>
        <button
          type="button"
          className="layer-create-btn"
          onClick={handleCreateLayer}
          title="Crear capa visual (solo editor)"
        >
          +
        </button>
        <span>{expanded ? '▼' : '▶'}</span>
      </div>
      {expanded && (
        <div className="panel-content">
          {editorLayers.map((layerName) => {
            const objectCount = objects.filter((obj) => obj.layerName === layerName).length;
            const entityCount = entities.filter((entity) => entityLayerAssignments[entity.id] === layerName).length;
            const totalCount = objectCount + entityCount;

            return (
                <div
                  key={layerName}
                  className={`layer-item ${activeLayer === layerName ? 'active' : ''}`}
                  onClick={() => setActiveLayer(layerName)}
                >
                  <div
                    className={`layer-visibility ${!layerVisibility[layerName] ? 'hidden' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleLayerVisibility(layerName);
                    }}
                  >
                    {layerVisibility[layerName] ? '👁' : '○'}
                  </div>
                  <span>{layerName}</span>
                  <span style={{ marginLeft: 'auto', color: 'var(--text-secondary)', fontSize: '0.75rem' }}>
                    {totalCount}
                  </span>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}
